import { render, staticRenderFns } from "./MypageReferrerModal.vue?vue&type=template&id=344f8ffa&scoped=true&"
import script from "./MypageReferrerModal.vue?vue&type=script&lang=js&"
export * from "./MypageReferrerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f8ffa",
  null
  
)

export default component.exports